module.exports = __webpack_public_path__ + "static/img/cop_sch_logo27.e4c890cf.png";